// import { Calendar } from "react-feather";

import {getStudents, getTeachers} from "./apiUtils";

// import LeaveDetails from "../Componant/Dashboard/Teacher/Profile/leaveDetails";
// import TeacherChange from "../Componant/Dashboard/TeacherChange/teacherChange";
// import StudentProfile from "../Pages/Dashboard/Student/student";
// import { EditProfile, Social, UpdateProfile } from "../utils/Constant";
// import AddStudent from "../Componant/Dashboard/Student/AddStudent/addStudent";
// import FindTeacher from "../Componant/Dashboard/Student/profile/findTeacher";
// import AeCalendar from "../Componant/Dashboard/Teacher/Profile/AeCalendar/ae-calendar";
// import NewPaymentLink from "../Componant/Dashboard/Student/profile/payment/new-paymentlink";

// import ChangeCourse from "../Componant/Dashboard/Student/profile/ChangeCourse/change-course";
// import UserProfile from "../Layout/Header/RightHeader/UserProfile/UserProfile";

export const CONFIG_BASE_DOMAIN = process.env.REACT_APP_CONFIG_BASE_DOMAIN;
/** Sibling of config.json — e.g. .../uat/adminEmailAccess.json */
export const EMAIL_ACCESS_CONFIG_URL = (() => {
  const base = process.env.REACT_APP_EMAIL_ACCESS_CONFIG_URL?.trim();
  if (base) return base;
  const configUrl = process.env.REACT_APP_CONFIG_BASE_DOMAIN || "";
  if (configUrl.includes("config.json")) {
    return configUrl.replace(/config\.json(?:\?.*)?$/, "adminEmailAccess.json");
  }
  return "";
})();
export const WEB_API_BASEURL = process.env.REACT_APP_WEBAPI_BASEURL;
/** Scheduler service (e.g. http://localhost:9012). Used for AE monthly airline slot bulk delete. */
export const UTILITY_BASEURL = process.env.REACT_APP_UTILITY_BASEURL;
export const PAYMENT_BASEURL = process.env.REACT_APP_PAYMENT_BASEURL;
export const RENEWAL_PAYMENT = process.env.REACT_APP_RENEWAL_BASEURL;
/** artium-class-ops-api: trial-class corrections. Empty where it is not deployed yet. */
export const CLASSOPS_BASEURL = (process.env.REACT_APP_CLASSOPS_BASEURL || "").replace(/\/$/, "");
/** artium-class-ops-api resource paths, appended to CLASSOPS_BASEURL. */
export const CLASSOPS_COMPLETE_PATH =
  process.env.REACT_APP_CLASSOPS_COMPLETE_PATH || "/api/v1/trial-class/complete";
export const CLASSOPS_MARK_COMPLETED_PATH =
  process.env.REACT_APP_CLASSOPS_MARK_COMPLETED_PATH || "/api/v1/trial-class/mark-completed";
/** artium-videocall-qa: AI lesson quality reports. Empty where it is not deployed yet. */
export const VIDEOCALL_QA_BASEURL = (process.env.REACT_APP_VIDEOCALL_QA_BASEURL || "").replace(/\/$/, "");
export const BLAZE_BASEURL = process.env.REACT_APP_BLAZE_BASEURL;
export const JOIN_URL = process.env.REACT_APP_JOIN_URL;
/** Demo class join host (different from paid video host). */
export const DEMO_JOIN_URL =
  process.env.REACT_APP_DEMO_JOIN_URL || process.env.REACT_APP_JOIN_URL;

/** Build student join link with the correct host + classType for demo vs paid. */
export const buildClassJoinUrl = (
  classId: string | number | null | undefined,
  isDemoClass: boolean
): string => {
  const base = (isDemoClass ? DEMO_JOIN_URL : JOIN_URL) || "";
  const id = classId != null ? String(classId).trim() : "";
  const classType = isDemoClass ? "demo" : "paid";
  if (!base || !id) return "";
  return `${base.replace(/\/$/, "")}/${id}?classType=${classType}`;
};
export const PAYMENT_CONFIG_BASE_DOMAIN = process.env.REACT_APP_PAYMENT_CONFIG_BASE_DOMAIN
export const AHA_MOMENT_BASEURL = process.env.REACT_APP_AHA_MOMENT;
export const TRANSACTION_BASEURL = process.env.REACT_APP_TRANSACTION_BASEURL;
/** API Gateway base for Demo Ops lead history (GET/POST /api/lead-history). */
export const DEMOOPS_HISTORY_BASEURL = process.env.REACT_APP_DEMOOPS_HISTORY_URL || "";

export const API_URLS = {

// class correction (artium-class-ops-api)
    completeTrialClass: `${CLASSOPS_BASEURL}${CLASSOPS_COMPLETE_PATH}`,
    markTrialClassCompleted: `${CLASSOPS_BASEURL}${CLASSOPS_MARK_COMPLETED_PATH}`,

// video call QA (artium-videocall-qa)
    videoCallQaLessons: `${VIDEOCALL_QA_BASEURL}/v1/classes`,
    videoCallQaLessonReport: `${VIDEOCALL_QA_BASEURL}/v1/classes/{lessonId}`,

// teacher profile
    UserProfile: `${WEB_API_BASEURL}/admin/admin/{userId}/profileAPI?credid={credentialId}`,
    getTeachers: `${WEB_API_BASEURL}/admin/teachers`,
    teacherLeaderTeachers: `${WEB_API_BASEURL}/admin/v1/teacher-leader/teachers?userId={userId}`,
    assignTeacherLeaderTeachers: `${WEB_API_BASEURL}/admin/v1/teacher-leader/teachers`,
    teacherLeaderLeaders: `${WEB_API_BASEURL}/admin/v1/teacher-leader/leaders`,
    markTeacherLeader: `${WEB_API_BASEURL}/admin/v1/teacher-leader/mark`,
    createTeacherLeader: `${WEB_API_BASEURL}/admin/v1/users`,
    updateUserRole: `${WEB_API_BASEURL}/admin/v1/user-role`,
    getActiveTeachers: `${WEB_API_BASEURL}/users/teachers/active`,
    getOfflineTeachers: `${WEB_API_BASEURL}/admin/offline/teacher/list`,
    getAddOfflineStudent: `${WEB_API_BASEURL}/offline/enrollments`,
    getCourses: `${WEB_API_BASEURL}/admin/teacher/course/level`,
    teacherFreeSlotCalendar: `${WEB_API_BASEURL}/admin/teacher/free-slot-calendar`,
    addTeacher: `${WEB_API_BASEURL}/users/register/teachers`,
    teacherProfile: `${WEB_API_BASEURL}/admin/teacher/profile?teacherId={teacherId}`,
    teacherClassCount: `${WEB_API_BASEURL}/admin/teacher/Classes/Count/{teacherId}`,
    editTeacherProfile: `${WEB_API_BASEURL}/admin/teacher/editprofile`,
    teacherStudent: `${WEB_API_BASEURL}/teacher/teacherStudents?teacherUserId={teacherUserId}`,
    aeTeacherStudent: `${WEB_API_BASEURL}/admin/teacher/students`,
    classNotMarked: `${WEB_API_BASEURL}/admin/pendingClassesToMark?teacherUserId={teacherUserId}`,
    noShowDetails: `${WEB_API_BASEURL}/admin/teacher/noshow/details?teacherId={teacherId}&fromDate={fromDate}&toDate={toDate}`,
    noShowDelete: `${WEB_API_BASEURL}/admin/teacher/noshow/details?teacherId=723&teacherNoshowClassId=3`,
    workingHours: `${WEB_API_BASEURL}/admin/teacherWorkingHours?teacherId={teacherId}`,
    updateWorkingHours: `${WEB_API_BASEURL}/admin/updateteacherWorkingHours`,
    LeaveDetails: `${WEB_API_BASEURL}/admin/TeacherLeaveHistory?teacherId={teacherId}`,
    addLeave: `${WEB_API_BASEURL}/admin/addLeaveBalance`,
    addLeaveBalanceH1H2: `${WEB_API_BASEURL}/admin/add/leave/balance/h1&h2`,
    leaveBalance: `${WEB_API_BASEURL}/admin/leaveBalance?teacherId={teacherId}`,
    leaveBalanceV2: `${WEB_API_BASEURL}/teacher/leaveBalance?teacherId={teacherId}`,
    calculateNumberOfLeaves: `${WEB_API_BASEURL}/course/calculate/leaves`,
    applyTeacherLeave: `${WEB_API_BASEURL}/course/applyTeacherLeave`,
    changeStatus: `${WEB_API_BASEURL}/users/teacher/status?mobileNumber={mobileNumber}&status={status}&lastDate={lastDate}&reason={reason}`,
    enableForPaid: `${WEB_API_BASEURL}/users/enable/paid?teacherId={teacherId}&action={action}`,
    enableForAllocationPriority: `${WEB_API_BASEURL}/admin/allocation/priority`,
    enableForNightSlots: `${WEB_API_BASEURL}/admin/enable/night/slots?teacherId={teacherId}&enableNightSlots={enabled}`,
    qaList: `${WEB_API_BASEURL}/admin/getQAScore?teacherId={teacherId}`,
    aeForm: `${WEB_API_BASEURL}/course/aeform/feedback?studentId={studentId}`,
    kysForm: `https://beta-blaze.artiumacademy.com/api/form/kycform-a2/{courseId}/{userId}`,
    QaButton: `https://trans.artiumacademy.com/process_transcript`,
    getQaEntries: `https://trans.artiumacademy.com/get_qa_entries/{teacherId}`,
    //teacher calendar
  AeCalendar:`${WEB_API_BASEURL}/admin/airline/slots?teacherId={teacherId}&fromDate={fromDate}&toDate={toDate}&parentTagId={parentTagId}`,
  addAeSlot:`${WEB_API_BASEURL}/course/add/AirlineSlot?teacherId={teacherId}&clientId={clientId}&ishalfHourSlot={ishalfHourSlot}&maxNumberOfSlots={maxNumberOfSlots}&categoryId={categoryId}`,
  deleteAe:`${WEB_API_BASEURL}/course/delete/airlineSlot?airlineTeacherSlotid={airlineTeacherSlotid}`,
  teacherSlotDelete:`${WEB_API_BASEURL}/admin/delete/teacherslot/{slotId}?slotid={slotId}`,
  insertSlot:`${WEB_API_BASEURL}/admin/insertteacherslot`,
  teacherScheduleTemplates:`${WEB_API_BASEURL}/admin/teachers/{teacherId}/schedule-templates`,
  aeUnavailability:`${WEB_API_BASEURL}/admin/teachers/{teacherId}/ae/unavailability`,
  fetchCalendar:`${WEB_API_BASEURL}/admin/calendar`,
  completedClass:`${WEB_API_BASEURL}/admin/class/complete`,
  activeLevel:`${PAYMENT_BASEURL}/api/academics/user/course-status/{studentUserId}?courseId={courseId}&status=active`,
  completeLesson:`${PAYMENT_BASEURL}/api/academics/user/class-lesson-completion?userId={studentUserId}&classId={classId}`,
  BEHAVIOURAL_ASSESSMENT : `${BLAZE_BASEURL}/api/assessment-questions/behavioural?courseId={courseId}`,
  ASSESSMENT_CRUD :`${PAYMENT_BASEURL}/api/academics/user/{assessmentType}`,
  ongoingLesson:`${PAYMENT_BASEURL}/api/academics/user/ongoing-lesson/{userId}/?levelId={levelId}`,
  classRecording:` ${BLAZE_BASEURL}/api/recordings/{teacherCredentialId}/{classId}`,
  // cancelClass:`${WEB_API_BASEURL}/admin/class/notconducted`,
  penalty:`${WEB_API_BASEURL}/admin/markFor/TeacherPenalty`,
  studentPenalty:`${WEB_API_BASEURL}/admin/markFor/StudentPenalty`,
  markAsJoin:`${WEB_API_BASEURL}/admin/mark/join/update?classId={classId}&userAction={action}`,
  courseLevel:`${PAYMENT_BASEURL}/api/academics/user/course-status/{userId}`,
  freeAttempt:`${WEB_API_BASEURL}/admin/student/penalty/attempt/update`,
  freeAttemptCount:`${WEB_API_BASEURL}/admin/get/student/free/penalty?studentId={studentId}&courseId={courseId}`,
  studentDemoComplete:`${WEB_API_BASEURL}/admin/studentdemocomplete/{studentId}`,
  getGraded:`${WEB_API_BASEURL}/admin/get/student/graded/certification?studentId={studentId}&courseId={courseId}&status={status}`,
  getStudents: `${WEB_API_BASEURL}/admin/students`,
  validateEmail:`${WEB_API_BASEURL}/users/ValidateNewUser1/{email}`,
  validateMobileNumber:`${WEB_API_BASEURL}/users/ValidateNewUser/%2B91/{mobileNumber}`,
  AddStudent:`${WEB_API_BASEURL}/admin/addstudents`,
  AddOfflineStudent:`${WEB_API_BASEURL}/admin/addStudent/offline`,
  StudentProfile:`${WEB_API_BASEURL}/admin/student/{credentialId}/profileAPI?studentId={studentId}`,
  UpdateProfile:`${WEB_API_BASEURL}/users/profile`,
  studentReactivate: `${WEB_API_BASEURL}/users/students/{studentId}/reactivate`,
  completedLessonByLevel:`${PAYMENT_BASEURL}/api/academics/user/lessons-count/{userId}?levelId={levelId}`,
  // stuHistory:`${WEB_API_BASEURL}/admin/get/user/perform/action?studentId={studentId}`,
  resetotp:`${WEB_API_BASEURL}/admin/reset/token/count?mobileNumber={mobileNumber}`,
  studentCourses:`${WEB_API_BASEURL}/admin/courses?studentId={studentId}`,
  gradedExamList: `${PAYMENT_BASEURL}/api/gradedexam/examlist?courseId={courseId}&userId={userId}`,
  gradedExamUserPaymentConfirmation: `${PAYMENT_BASEURL}/api/gradedexam/user-payment-confirmation`,
  membderShip:`${WEB_API_BASEURL}/admin/membership/update?studentId={studentId}&courseId={courseId}&membershipType={membershipType}`,
  getMemberShip:`${WEB_API_BASEURL}/admin/student/{studentId}/course/{courseId}/membership`,
  loginOtp:`${WEB_API_BASEURL}/admin/temp/otp?credentialId={credentialId}`,
  syncSalesForce:`${WEB_API_BASEURL}/student/salesforce/sync?studentId={studentId}`,
  Profile:`${WEB_API_BASEURL}/users/get/user/profile/{userId}`,
  // kysForm:`https://n7iw1q9yki.execute-api.ap-southeast-1.amazonaws.com/api/form/kycform/43/48558`,
  FindTeacherStudent:`${WEB_API_BASEURL}/student/onboarding/find/teacher`,
  FindTeacherStudentV2:`${WEB_API_BASEURL}/admin/onboarding/find/teacher/v2`,
  // Onboarding v3 (same contract as dashboard /onboardingv3)
  onboardingTimeBucketsV3: `${WEB_API_BASEURL}/admin/onboarding/v3/time-buckets`,
  onboardingTeachersV3: `${WEB_API_BASEURL}/admin/onboarding/v3/teachers`,
  onboardingSchedulePreviewV3: `${WEB_API_BASEURL}/admin/onboarding/v3/schedule-preview`,
  // feedbackforfindTeacher:`${WEB_API_BASEURL}/course/aeform/feedback?studentId={studentId}`,
  referralLink:`${BLAZE_BASEURL}/api/referral/generateReferral`,
  classHistory:`${WEB_API_BASEURL}/admin/studentClassHistory?studentId={studentId}&courseId={courseId}`,
  demoStudentClassCalendar:`${WEB_API_BASEURL}/admin/studentclass/{studentId}?size={size}&page={page}&studentId={studentId}&courseId={courseId}`,
// stuent calendar
  calendarData:`${WEB_API_BASEURL}/admin/classes?studentUserId={studentUserId}&courseId={courseId}`,
  reschedule:`${WEB_API_BASEURL}/admin/class/reschedule`,
  schedule:`${WEB_API_BASEURL}/admin/class/schedule`,
  studentPaidClassSchedule: `${WEB_API_BASEURL}/student/class/schedule`,
  myClassesData: `${WEB_API_BASEURL}/student/classes?studentUserId={studentUserId}&courseId={courseId}`,
  listDemoFreeSlots:`${WEB_API_BASEURL}/course/listFreeSlots/{userId}?studentId={userId}&customParameter=adminportal`,
  allocateTeacherForBooking:`${WEB_API_BASEURL}/course/allocateTeacherForBooking?status=prebook`,
  updateStudentInterestTag:`${WEB_API_BASEURL}/users/updateTag/{studentId}/{tagId}`,
  userCampaign:`${WEB_API_BASEURL}/users/campaign/{userId}`,
  triggerMixpanel: `${BLAZE_BASEURL}/api/trigger-mixpanel/`,
  airlineTeacherList:`${WEB_API_BASEURL}/admin/airline/teacher?classScheduleId={classScheduleId}`,
  reassignAirlineTeacher:`${WEB_API_BASEURL}/admin/airline/resassign/teacher?classScheduleId={classScheduleId}&airlineTeacherSlot={airlineTeacherSlot}`,
  completeDemoClass:`${WEB_API_BASEURL}/course/teacher/completeclass?st={st}&csid={csid}&tid={tid}&cancelst=undefined&cancellationReasonByStudent=undefined&pushNotification=true`,
  fetchClassesCancelledByTeacher:`${WEB_API_BASEURL}/admin/fetchClassesCancelledByTeacher?studentId={studentId}`,
  cancelTheClass:`${WEB_API_BASEURL}/admin/class/cancel`,
  joinUrl:`${JOIN_URL}/{classId}?classType={classType}`,
  demoJoinUrl:`${DEMO_JOIN_URL}/{classId}?classType=demo`,
  generateZoomLink:`${WEB_API_BASEURL}/admin/generate/zoom/link?studentCourseClassId={classId}`,
  previewSchedule: `${WEB_API_BASEURL}/student/onboarding/preview-schedule`,
  studentClassSchedule: `${WEB_API_BASEURL}/student/onboarding/admin-book-fixed`,
  updateOnboardingStatus: `${WEB_API_BASEURL}/student/onboarding/status?enrollmentId={enrollmentId}&status={status}`,
  assignOnboardingTeacher: `${WEB_API_BASEURL}/student/onboarding/assign/teacher?enrollmentId={enrollmentId}&teacherId={teacherId}`,
  teacherAssignmentAlert: `${WEB_API_BASEURL}/admin/v1/teacher-assignment/alert?enrollmentId={enrollmentId}&teacherId={teacherId}`,
// teacher profile

    completedToNotConducted: `${WEB_API_BASEURL}/admin/class/status/update/completed-to-notconducted?classId={classId}`,
    completedToNoShow: `${WEB_API_BASEURL}/admin/class/status/update/completed-to-noshow?classId={classId}&status={status}`,
    scheduleToCompleted: `${WEB_API_BASEURL}/admin/class/status/update/schedule-to-completed?classId={classId}`,
    scheduleToNoShow: `${WEB_API_BASEURL}/admin/class/status/update/schedule-to-noshow?classId={classId}&classStatus={classStatus}`,
    // noShowToCompleted:`https://uat.artiumacademy.com/api/admin/class/status/update/noshow-to-completed?classId={classId}`,
    // noShowToNotConducted:`https://uat.artiumacademy.com/api/admin/class/status/update/noshow-to-notconducted?classId={classId}`,
    // notConductedToNowShow:`https://uat.artiumacademy.com/api/admin/class/status/update/notconducted-to-noshow?classId={classId}&status={status}`,
    // notConductedToComplted:`https://uat.artiumacademy.com/api/admin/class/status/update/notconducted-to-completed?classId=152408`,
    //change teacher
    changeTeacher: `${WEB_API_BASEURL}/admin/changeTeacher`,
    changeOfflineTeacher: `${WEB_API_BASEURL}/offline/admin/teacher-change`,

    markcompleteLevel: `${PAYMENT_BASEURL}/api/academics/user/course-status`,
    checkPolicy: `${WEB_API_BASEURL}/admin/isStudentnewPolicy?studentId={studentId}&courseId={courseId}`,
    changePolicy: `${WEB_API_BASEURL}/admin/isStudentnewPolicy`,

//offlineapi
    weeklyslotoffline: `${WEB_API_BASEURL}/offline/teacher-slots/weekly-slots-with-students?courseId={courseId}&centerId={centerId}`,
    teacherSlotDetails: `${WEB_API_BASEURL}/offline/v1/schedule-templates/{slotId}`,
    addStduentOffline: `${WEB_API_BASEURL}/offline/student-slots/assign`,
    removeStudentOffline: `${WEB_API_BASEURL}/offline/student-slots/remove`,
    getStudentsOffline: `${WEB_API_BASEURL}/offline/offline-users/students?centerId={centerId}&courseId={courseId}`,
    getTeachersOffline: `${WEB_API_BASEURL}/offline/offline-users/teachers?centerId={centerId}&courseId={courseId}`,
    addCompensatoryOrRestrictedClass: `${WEB_API_BASEURL}/offline/student-slots/{slotId}`,
    getStudentsSlotDetails: `${WEB_API_BASEURL}/offline/student-slots/students/{studentId}?fromDate={fromDate}&toDate={toDate}`,
    sendSlackAlert: `${WEB_API_BASEURL}/offline/slack-alert`,
    getOfflineStudentSlots: `${WEB_API_BASEURL}/offline/student-slots/all/{studentId}?courseId={courseId}&page={page}&size={size}`,
    getTeacherSlots: `${WEB_API_BASEURL}/offline/teacher/slots/my-slots?teacherUserId={teacherUserId}&page={page}&size={size}&fromDate={fromDate}&toDate={toDate}`,
    rescheduleOfflineSlot: `${WEB_API_BASEURL}/offline/student-slots/reschedule`,

    updateLessonStatus: `${PAYMENT_BASEURL}/api/academics/user/update-lesson-status`,

//lessonMark
    getCourseLevel: `${PAYMENT_BASEURL}/api/lms/course/level/{courseId}`,
    getStatusOfLevel: `${PAYMENT_BASEURL}/api/academics/user/course-status/{studentUserId}?courseId={courseId}`,
    getLevelLesson: `${PAYMENT_BASEURL}/api/lms/level/lesson/{levelId}`,
    completedActiveLevelLessons: `${PAYMENT_BASEURL}/api/academics/user/completed-lessons/{studentUserId}?levelId={levelId}`,
    markAsCompleteLesson: `${PAYMENT_BASEURL}/api/academics/user/completed-lesson`,
    getClassId: `${WEB_API_BASEURL}/student/classes/completed?studentUserId={studentUserId}&courseId={courseId}`,
    updateIs30MinsClass: `${WEB_API_BASEURL}/admin/thirty/minute/toggle?studentUserId={studentUserId}&courseId={courseId}&is30Mins={is30Mins}&reason={reason}`,
    schedulerBaseURL: `${WEB_API_BASEURL}/admin/scheduler/monthly-slots/bulk-delete-airline-slots`,
    schedulerBulkDeleteFreeSlots: `${WEB_API_BASEURL}/admin/scheduler/monthly-slots/bulk-delete-slots`,






  // student payment
  getPackageList:`${PAYMENT_BASEURL}/api/payment/student-onboarding-package/{studentId}`,
  createPackage:`${PAYMENT_BASEURL}/api/payment/v2/onboarding-package/{studentId}/{courseId}?overrite=true`,
  getAccountDetails:`${PAYMENT_BASEURL}/api/payment/v2/account-detail/{levelId}`,
  externalPayment:`${PAYMENT_BASEURL}/api/payment/v2/external-payment`,
  savePackage:`${PAYMENT_BASEURL}/api/payment/v2/onboarding-package`,
  // split payment
  splitPreview:`${PAYMENT_BASEURL}/api/payment/v2/split-preview`,
  createSplitPackage:`${PAYMENT_BASEURL}/api/payment/v2/create-split-package`,
  updateSplitPackage:`${PAYMENT_BASEURL}/api/payment/v2/update-split-package`,
  // offline payment (renewal payment link / record external payment) - mirrors artium-admin-portal offline save
  counsellorCentre:`${WEB_API_BASEURL}/admin/counsellor/centre?uId={uId}`,
  offlineDirectPayment:`${PAYMENT_BASEURL}/api/order/directpayment`,
  offlineExternalPayment:`${PAYMENT_BASEURL}/api/payment/external-payment`,
  offlineCustomerId:`${PAYMENT_BASEURL}/api/payment/v3/customer-id?studentId={studentId}&currency={currency}`,
  // fetchTeacherByCourseId:`${WEB_API_BASEURL}/admin/teachers?courseId={courseId}`,
  newFetchTeacherByCourseId:`${WEB_API_BASEURL}/admin/filterteacher`,
  filteredTeacherByCourseId:`${WEB_API_BASEURL}/admin/filterteacher`,
  getArtiumCash:`${BLAZE_BASEURL}/api/artium-cash/{userId}?userType={userType}`,
  getCoursePrice:`${BLAZE_BASEURL}/api/courseDetails/v2/getMultipleCoursePrice?levelIds={levelIds}&countryCode={countryCode}&countryName={countryName}`,
  // offline course price - price is resolved per centre from each level's centerPriceMap
  getMultipleOfflineCoursePrice:`${BLAZE_BASEURL}/api/courseDetails/v2/getMultipleOfflineCoursePrice?levelIds={levelIds}&countryCode={countryCode}&centerId={centerId}`,
  walletPoints:`${BLAZE_BASEURL}/api/artium-cash/{userId}?userType={userType}`,
  cashWallet:`${BLAZE_BASEURL}/api/artium-cash/{userId}`,
  renewalPayment:`${RENEWAL_PAYMENT}/api/payment/external-payment/{studentId}`,
  courseExtensionPaymentLink: `${RENEWAL_PAYMENT}/api/payment/course-extension/payment-link`,
  courseExtensionList: `${RENEWAL_PAYMENT}/api/payment/course-extension/{studentUserId}`,
  courseExtensionDelete: `${RENEWAL_PAYMENT}/api/payment/course-extension/delete`,

  // offline subscription renewals (Action Centre)
  renewalsList: `${WEB_API_BASEURL}/offline/renewals`,
  renewalsCallDecisions: `${WEB_API_BASEURL}/offline/renewals/{enrollmentId}/call-decisions`,


// certificate
    getCertificate: `${PAYMENT_BASEURL}/api/academics/user/course-certificates/{userId}?courseId={courseId}`,
    reGenerateCertificate: `${PAYMENT_BASEURL}/api/academics/user/regenerate-certificate`,

    // trasaction list
    triggerRetryPayment: `${PAYMENT_BASEURL}/api/payment/v2/retry-class-creation`,
    getExternalPayment: `${PAYMENT_BASEURL}/api/payment/external-payment/{studentId}`,
    getAllPayments: `${PAYMENT_BASEURL}/api/order/paymentlink/{studentId}`,
    getInvoicePdf: `${PAYMENT_BASEURL}/api/payment/invoice-pdf/{invoiceId}`,
    getRefundList: `${PAYMENT_BASEURL}/api/payment/refund-request/{studentId}`,
    getSubcriptionCourse: `${WEB_API_BASEURL}/admin/refund/data?studentId=29364`,
    refundRequest: `${PAYMENT_BASEURL}/api/payment/refund-request`,
    blockRnr: `${WEB_API_BASEURL}/admin/rnr`,
    RnrHistory: `${WEB_API_BASEURL}/admin/rnrHistory?fromDate={fromDate}&toDate={toDate}`,

    SocialTrigger: `${WEB_API_BASEURL}/users/payment/notification`,
    // Compensation Report
    compensation: `${WEB_API_BASEURL}/course/teacherBilling?fromDate={fromDate}&toDate={toDate}&emailId={emailId}`,
    getReportsForAdmin: `${BLAZE_BASEURL}/api/teacher-report/get_reports_for_admin?month={month}`,
    getReportsForAdminRange: `${BLAZE_BASEURL}/api/teacher-report/get_reports_for_admin?start_month={startMonth}&end_month={endMonth}`,
    getReportsForTeacherLeaderForAdmin: `${BLAZE_BASEURL}/api/teacher-report/get_reports_for_teacher_leader_for_admin?month={month}&teacher_leader_user_id={teacherLeaderUserId}&page={page}&limit={limit}`,
    getReportsForTeacherLeaderForAdminRange: `${BLAZE_BASEURL}/api/teacher-report/get_reports_for_teacher_leader_for_admin?start_month={startMonth}&end_month={endMonth}&teacher_leader_user_id={teacherLeaderUserId}&page={page}&limit={limit}`,
    getTeacherMetricPastMonthsData: `${BLAZE_BASEURL}/api/teacher-report/get_teacher_metric_past_months_data?teacherId={teacherId}&parameter={parameter}`,
    // leaveRequest
    leaveRequest: `${WEB_API_BASEURL}/admin/TeacherLeaveHistory?page={page}&limit={limit}`,
    approveLeave: `${WEB_API_BASEURL}/admin/approve/Teacher/Leave/h1&h2?transactionId={transactionId}&transactionStatus={transactionStatus}`,
    getAffectedClassCount: `${WEB_API_BASEURL}/admin/classes/affected`,
    listOfAffectedCount: `${WEB_API_BASEURL}/admin/teacher/leave/request`,
    // teacher payout
    uploadPayout: `${WEB_API_BASEURL}/users/teacherpayoutexceltojason?fromDate={fromDate}&toDate={toDate}`,
    deletePayout: `${WEB_API_BASEURL}/users/deletePayslips?fromDate={fromDate}&toDate={toDate}`,
    teacherLedger: `${WEB_API_BASEURL}/teacher/teacher/ledger?teacherUserId={teacherUserId}&fromDate={fromDate}&toDate={toDate}`,
    teacherLedgerAdjustment: `${WEB_API_BASEURL}/teacher/teacher/ledger/adjustment`,
    addStudentConvo: `${BLAZE_BASEURL}/api/conversation/`,
    getConversationData: `${BLAZE_BASEURL}/api/conversation/{studentUserId}/all`,
    getConversationSummary: `${BLAZE_BASEURL}/api/conversation/{studentUserId}/summary`,
    rmFeedback: `${BLAZE_BASEURL}/api/rm-feedback/`,
// teacherChange
    TeacherChange: `${WEB_API_BASEURL}/admin/working/teachers`,
    studentTeacherChange: `${WEB_API_BASEURL}/admin/working/students?type={type}&teacherId={teacherId}`,
    triggerTeacher: `${WEB_API_BASEURL}/admin/detach/students?teacherId={teacherId}`,

//referrals
    getReferral: `${BLAZE_BASEURL}/api/referral/cashback-requests?pageSize={pagesize}&sortOrder={order}`,
    referralAction: `${BLAZE_BASEURL}/api/referral/cashback-update/{userId}`,

//refund
    getRefundData: `${PAYMENT_BASEURL}/api/payment/refund-request`,
    approveRequestRefund: `${PAYMENT_BASEURL}/api/payment/v2/approve-refund-request`,
    rejectRequestRefund: `${PAYMENT_BASEURL}/api/payment/v2/reject-refund-request`,
// change course
    courseListOfStudent: `${WEB_API_BASEURL}/admin/courseListOfStudent?studentId={studentId}`,
    totalMovingClassPrice: `${WEB_API_BASEURL}/admin/totalMovingClassPrice`,
//changeCourse:`${WEB_API_BASEURL}/admin/courseChange`,
    changeCourse: `${PAYMENT_BASEURL}/api/payment/change-course`,
    transactionCourseChange: `${PAYMENT_BASEURL}/api/payment/v2/transaction-course-change`,
//courseTransfer:`${WEB_API_BASEURL}/admin/course/transfer`,
    courseTransfer: `${PAYMENT_BASEURL}/api/payment/change-course`,
    changeLevel: `${PAYMENT_BASEURL}/api/academics/user/user-course-level`,
    classDetails: `${WEB_API_BASEURL}/admin/student/class/count?studentId={studentId}&courseId={courseId}`,


//expirey history
    expireyHistory: `${WEB_API_BASEURL}/admin/student/expiry/details?studentId={studentId}&courseId={courseId}`,
    deductHistory: `${WEB_API_BASEURL}/admin/classes/deduct/details?studentId={studentId}`,
    extendExpriey: `${WEB_API_BASEURL}/admin/extend/expiry/academic2`,
    extendOfflineEnrollmentExpiry: `${WEB_API_BASEURL}/offline/enrollments/{enrollmentId}/expiry-extensions`,
    numberOfClassesExpiry: `${WEB_API_BASEURL}/admin/upcoming/student/classes/expiry?studentId={studentId}&courseId={courseId}`,
    changeTeacherHistory: `${WEB_API_BASEURL}/admin/student/change/teacher/details?studentId={studentId}`,

//QaPolicy
    getQaList: `${WEB_API_BASEURL}/admin/getQAScore`,
    updateQaList: `${WEB_API_BASEURL}/admin/updateQAScore`,
// qaReports:`${WEB_API_BASEURL}/admin/QAreport`,
    addNewQaList: `${WEB_API_BASEURL}/admin/teacherQAScore`,
    generateQaReport: `${WEB_API_BASEURL}/admin/QAreport?fromDate={fromDate}&toDate={toDate}&teacherId={teacherId}`,
    getQAScore: `${WEB_API_BASEURL}/admin/get/teacher/quality/analysis/{teacherUserId}`,

//aha moment
    getAhaMoment: `${AHA_MOMENT_BASEURL}/api/admin/ahamoments?pageSize=20`,

//community
addCommunity:`${WEB_API_BASEURL}/admin/add/community`,
removeCommunity:`${WEB_API_BASEURL}/admin/community/remove`,
getEventCount:`${BLAZE_BASEURL}/api/community/geteventcount`,
getCadenceSchedule:`${BLAZE_BASEURL}/api/community/admin/cadence/schedule`,
processCommunityUpload:`${BLAZE_BASEURL}/api/community/admin/content/process-upload`,
createCommunityBroadcast:`${BLAZE_BASEURL}/api/community/admin/broadcast`,
updateCommunityBroadcast:`${BLAZE_BASEURL}/api/community/admin/broadcast`,
deleteCommunityBroadcast:`${BLAZE_BASEURL}/api/community/admin/broadcast`,
getZoomRecordings:`${WEB_API_BASEURL}/utility/v1/zoom-recordings/search`,
transactionByCreatedDate: `${TRANSACTION_BASEURL}/api/payment/transactionbycreateddate`,
aeAirlineBookings: `${WEB_API_BASEURL}/admin/airlineBookings?slotDate={slotDate}&ParentTagId={parentTagId}`,
  aeAirlineDetails: `${WEB_API_BASEURL}/admin/airline/details?fromDate={fromDate}&toDate={toDate}`,
  aeCategoryWiseSlots: `${WEB_API_BASEURL}/admin/ae/slots?date={date}`,
  aeConversion: `${WEB_API_BASEURL}/admin/ae/conversion?fromDate={fromDate}&toDate={toDate}`,

// Demo Ops
demoOpsAdminLeads: `${WEB_API_BASEURL}/admin/leads`,
demoOpsAgentStatus: `${WEB_API_BASEURL}/admin/agent?agentId={agentId}`,
demoOpsAgentAvailability: `${WEB_API_BASEURL}/admin/status`,
demoOpsAgentShiftStatus: `${WEB_API_BASEURL}/admin/agent/shift/status`,
demoOpsUpdateAgentLead: `${WEB_API_BASEURL}/admin/new/update/agent/lead`,
demoOpsDemoClassLink: `${WEB_API_BASEURL}/admin/demoClassLink?classId={classId}&studentId={studentId}`,
demoOpsLeadHistory: `${DEMOOPS_HISTORY_BASEURL}/api/lead-history`,
demoOpsLeadHistoryByStudent: `${DEMOOPS_HISTORY_BASEURL}/api/lead-history/{studentId}`,
demoOpsClickToCall: `${BLAZE_BASEURL}/api/site/call-agent-customer`,
demoOpsActiveShifts: `${WEB_API_BASEURL}/admin/agents/shifts`,
demoOpsFindAgents: `${WEB_API_BASEURL}/admin/find/agents`,
demoOpsAddDeleteAgents: `${WEB_API_BASEURL}/admin/add/and/delete/agents`,
demoOpsUpdateAgentDetails: `${WEB_API_BASEURL}/admin/update/agent/details`,
  

    subjects: `${WEB_API_BASEURL}/admin/subjects`,
    chapters: `${WEB_API_BASEURL}/admin/chapters`,
    topics: `${WEB_API_BASEURL}/admin/topics`,
    lessons: `${WEB_API_BASEURL}/admin/lessons`,
    quizzes: `${WEB_API_BASEURL}/admin/quizzes`,
    questions: `${WEB_API_BASEURL}/admin/questions`,
    options: `${WEB_API_BASEURL}/admin/options`,
    answers: `${WEB_API_BASEURL}/admin/answers`,
    credentials: `${WEB_API_BASEURL}/admin/credentials`,
    login: `${WEB_API_BASEURL}/auth/login`,
    logout: `${WEB_API_BASEURL}/auth/logout`,
    register: `${WEB_API_BASEURL}/auth/register`,
    forgotPassword: `${WEB_API_BASEURL}/auth/forgot-password`,
    resetPassword: `${WEB_API_BASEURL}/auth/reset-password`,
    changePassword: `${WEB_API_BASEURL}/auth/change-password`,
    profile: `${WEB_API_BASEURL}/auth/profile`,
    upload: `${UTILITY_BASEURL}/upload`,
    download: `${UTILITY_BASEURL}/download`,
    delete: `${UTILITY_BASEURL}/delete`,
    utilityTimezones: `https://blaze.artiumacademy.com/api/utility/timezones`,
    config: `${CONFIG_BASE_DOMAIN}`,

// AE/TE Slots Dashboard (artium-admin-service, /api/v1/dashboard)
// NOTE: hardcoded to local :9012 for TEST only — swap back to `${UTILITY_BASEURL}` before prod.
    dashboardSlotHeatmap: `${WEB_API_BASEURL}/admin//v1/dashboard/slots/heatmap`,
    dashboardSlotHeatmapTeachers: `${WEB_API_BASEURL}/admin//v1/dashboard/slots/heatmap/teachers`,
    dashboardConductConvert: `${WEB_API_BASEURL}/admin//v1/dashboard/conduct-convert`,

//transactions

  // Teacher Escalation
  teacherEscalationList: `${WEB_API_BASEURL}/teacher/escalation/list`,
  teacherEscalationByTeacher: `${WEB_API_BASEURL}/teacher/escalation/by-teacher`,
  teacherEscalationStats: `${WEB_API_BASEURL}/teacher/escalation/stats`,
  teacherEscalationById: `${WEB_API_BASEURL}/teacher/escalation/{id}`,
  teacherEscalationByTicket: `${WEB_API_BASEURL}/teacher/escalation/ticket/{ticketId}`,
  teacherEscalationCreate: `${WEB_API_BASEURL}/teacher/escalation`,
  teacherEscalationValidate: `${WEB_API_BASEURL}/teacher/escalation/{id}/validate`,
  teacherEscalationAction: `${WEB_API_BASEURL}/teacher/escalation/{id}/action`,
}